<template>
    <v-container>
        <v-row v-if="['displays', 'displaysUnits', 'displaysAdministrators'].includes(routeName) && isAdmin">
            <v-col>
                <v-tabs stacked icons-and-text color="light-green" class="top-menubar">
                    <v-tab :to="{ name: 'displaysUnits' }" data-cy="units-tab">
                        <v-icon>meeting_room</v-icon>
                        <span v-if="isNotMobile" class="mt-2">Fakulty a součásti</span>
                    </v-tab>
                    <v-tab :to="{ name: 'displaysAdministrators' }" data-cy="access-tab">
                        <v-icon>account_box</v-icon>
                        <span v-if="isNotMobile" class="mt-2">Uživatelé a oprávnění</span>
                    </v-tab>
                </v-tabs>
                <v-divider />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <router-view />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';

const { proxy } = getCurrentInstance();
const route = useRoute()

const routeName = computed(() => route.name);
const isAdmin = computed(() => proxy.$auth.getRoles().includes('ADMIN'));
const isNotMobile = computed(() => !proxy.$vuetify.display.xs);
</script>

<style scoped>
    .top-menubar {
        box-shadow: 2px solid #c4c4c4;
    }
</style>
